<template>
  <v-dialog :value="showContact" max-width="480" @input="closeDialog" :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card class="py-3 px-7">
      <v-card-actions :class="$vuetify.breakpoint.xsOnly ? '' : 'pa-0'">
        <v-spacer></v-spacer>

        <v-btn icon @click="showContactPopup(false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
      <h4 class="font font--h2-2 mb-7 name pa-0">Контакты</h4>
      <div class="d-flex mb-6">
        <v-icon class="mr-6">mdi-phone</v-icon>
        <div>
          <a href="tel:88004441085" class="font mr-2">8 (800) 444-10-85</a><br v-if="$vuetify.breakpoint.xsOnly" />
          (с 9:00 до 18:00 по Москве)
        </div>
      </div>

      <div class="d-flex mb-6">
        <v-icon class="mr-6">mdi-email-outline</v-icon>
        <a href="mailto:agent@modulbank.ru" class="font">agent@modulbank.ru</a>
      </div>

      <div class="d-flex mb-6">
        <v-icon class="mr-6"> mdi-telegram</v-icon>
        <a href="https://t.me/modul_partner_bot" target="_blank" class="font">@modul_partner_bot</a>
      </div>

      <div class="d-flex mb-5">
        <v-icon class="mr-6"> mdi-whatsapp</v-icon>
        <a href="https://wa.me/79958881703" target="_blank" class="font">+7 (995) 888-17-03 </a>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapMutations, mapState } from "vuex";

export default {
  name: "ContactPopup",

  computed: {
    ...mapState("common", ["showContact"]),
  },

  methods: {
    ...mapMutations("common", ["showContactPopup"]),

    closeDialog() {
      this.showContactPopup(false);
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.name {
  font-weight: 400;
  font-size: 24px;
}
.v-dialog--fullscreen > .v-card {
  padding: 20px !important;
}
</style>
